import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Observable, Subject, defer, isObservable, of } from 'rxjs';
import { startWith, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'insol-table',
  templateUrl: './table.component.html',
})
export class TableComponent implements OnChanges {
  @Input() columns: string[];
  @Input() columnsDisplay: string[];
  @Input() cellCssClasses: (element: any) => string[];
  @Input() tableCssClasses: string[];
  @Input() enableSelection: boolean;
  @Output() selectionChange = new EventEmitter<any[]>();

  dataSource$: Observable<any[]>;
  allColumns: string[];
  selection = new SelectionModel<any>(true);

  private _dataSource: Observable<any[]> | any[];
  private dataSourceChange$ = new Subject<Observable<any> | any[]>();

  get dataSource(): Observable<any[]> | any[] {
    return this._dataSource;
  }
  @Input() set dataSource(value: Observable<any[]> | any[]) {
    this._dataSource = value;
    this.dataSourceChange$.next(value);
  }

  constructor() {
    this.dataSource$ = defer(() => this.dataSourceChange$.pipe(startWith(this.dataSource))).pipe(
      switchMap((dataSource) => {
        if (isObservable(dataSource)) {
          return dataSource as Observable<any[]>;
        }
        return of(dataSource as any[]);
      }),
      tap(() => this.selection.clear())
    );

    this.selection.changed.subscribe(() => {
      this.selectionChange.next(this.selection.selected);
    });
  }

  ngOnChanges(): void {
    let allColumns = [];
    if (this.enableSelection) {
      allColumns = ['$select'];
    }
    this.allColumns = [...allColumns, ...this.columns];
  }

  display(column: string): string {
    const index = (this.columns || []).indexOf(column);
    if (index === -1) {
      return '';
    }

    return this.columnsDisplay[index];
  }

  type(value: any): string {
    if (value && Array.isArray(value)) {
      return 'array';
    } else if (value && value instanceof Date && !isNaN(value.valueOf())) {
      return 'DateTime';
    } else {
      return typeof value;
    }
  }

  longValueName(shortValueName: string): string {
    if (shortValueName.startsWith('$short')) {
      return shortValueName.replace('$short', '$long');
    }

    return null;
  }

  getCellCssClasses(element: any): string {
    return ((this.cellCssClasses && this.cellCssClasses(element)) || []).join(' ');
  }

  getTableCssClasses(): string {
    return `mat-elevation-z8 table-auto ${(this.tableCssClasses || []).join(' ')}`;
  }
}
